module.exports = __webpack_public_path__ + "static/media/background-home.dd6044c3.png";